<div *ngIf="vm$ | async as vm">
  <div *ngIf="vm.perspectives?.length > 0" fxLayout="row" fxLayoutAlign="end center">
    <p class="flex-grow-0 flex-shrink-0 text-sm font-light text-left text-black mr-5">
      Perspectives
    </p>
    <mat-form-field floatLabel="never" class="perspectives-field">
      <mat-label>{{ vm.selectedName | translate : locale | async }}</mat-label>
      <mat-select
        [matMenuTriggerFor]="perspectives"
        [value]="vm.selected"
      ></mat-select>
      <mat-menu #perspectives="matMenu" class="item-menu">
        <button
          mat-menu-item
          *ngFor="let item of vm.perspectives"
          (click)="selectedPerspectiveChanged(item)"
        >
          {{ item.name | translate : locale | async }}
        </button>
      </mat-menu>
    </mat-form-field>
  </div>
</div>
